const emptyObject = {};
const emptyArray = [];
const emptyString = '';
const defaultFormMode = 'create';

export const getAgenciesGridSortCriteria = state => state.agencies.agenciesGridSortCriteria;

export const getCredentialsGridSortCriteria = state => state.agencies.credentialsGridSortCriteria;

export const getAgenciesFilters = state => state.agencies.agenciesFilters || emptyObject;

export const selectProfileFormIsEditable = state => state.agencies.profileForm.isEditable || false;

export const selectProfileFormIsLoading = state => state.agencies.profileForm.isLoading || false;

export const selectAgenciesList = state => state.agencies.agenciesList.list || emptyArray;

export const selectAgenciesListIsLoading = state => state.agencies.agenciesList.isLoading || false;

export const selectCurrentSelectedAgencyId = state =>
  state.agencies.agenciesList.currentSelectedAgencyId || emptyString;

export const selectCurrentSelectedAgency = state => {
  const list = selectAgenciesList(state);
  const id = selectCurrentSelectedAgencyId(state);
  const position = list.findIndex(agency => agency.agencyID.toString() === id.toString());

  return list[position] || emptyObject;
};

export const selectCredentialsList = state => state.agencies.credentialsList.list || emptyArray;

export const selectCredentialsListIsLoading = state =>
  state.agencies.credentialsList.isLoading || false;

export const selectCurrentSelectedCredentialId = state =>
  state.agencies.credentialsList.currentSelectedCredentialId || emptyString;

export const selectCurrentSelectedCredential = state => {
  const list = selectCredentialsList(state);
  const id = selectCurrentSelectedCredentialId(state);
  const position = list.findIndex(credential => credential.aggregatorID === id);

  return list[position] || emptyObject;
};

export const selectShowCredentialForm = state => state.agencies.credentialForm.show || false;

export const selectCredentialFormIsLoading = state =>
  state.agencies.credentialForm.isLoading || false;

export const selectCredentialFormMode = state =>
  state.agencies.credentialForm.formMode || defaultFormMode;
